<div
    class="lg-breadcrumb__element lg-breadcrumb__element--toolname"
    [class.lg-breadcrumb__element--clickable]="!!homeId && _state.length !== 0"
    (click)="_navigateHome($event)"
    (keydown.enter)="_navigateHome($any($event))"
    [tabindex]="-1"
>
    <div>{{ toolNameLc | lgTranslate: toolNameParams }}</div>
</div>
@for (element of _state; track trackId(element); let index = $index) {
    <div
        class="lg-breadcrumb__element lg-breadcrumb__element--clickable"
        [class.lg-breadcrumb__element--active]="_activeIndex === index"
        #breadcrumb
        (click)="_showMenu($event, index, breadcrumb)"
        (keydown.enter)="_showMenu($any($event), index, breadcrumb)"
        [tabindex]="0"
        (blur)="_maybeHidePopups($event)"
    >
        <div class="lg-breadcrumb__arrow">
            <lg-icon icon="icon-arrow-down"></lg-icon>
        </div>
        <div
            class="lg-breadcrumb__element__text"
            [class.lg-breadcrumb__element__text--narrowed]="
                isNarrowedChildren(index) ?? element.narrowed
            "
        >
            {{ (element.namePrefix || "") + element.name }}
        </div>
    </div>
}
